module.exports = __webpack_public_path__ + "img/dongji_ps_11.d6d5a7f2.jpg";